import Vue from 'vue';
import Router from 'vue-router';
// import Signup from '@/views/SignUp.vue';
//import Login from '@/views/Login.vue';
//import Logout from '@/views/Logout.vue';
//import Profile from '@/views/Profile.vue';
import Overview from '@/views/Overview.vue';
import Pages from '@/views/Pages.vue';
import EditPage from '@/views/EditPage.vue';
import AuthGuard from '@/router/auth-guard.js';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } 
      return { x: 0, y: 0 }
    
  },
  routes: [
    {
      path: '/',
      name: 'overview',
      component: Overview,
      beforeEnter: AuthGuard,
    },
    {
      path: '/pages',
      name: 'pages',
      component: Pages,
      beforeEnter: AuthGuard,
    },
    {
      path: '/page/:guid',
      name: 'edit-page',
      component: EditPage,
      props: true,
      beforeEnter: AuthGuard,
    },
    /*
    {
      path: '/signup',
      name: 'signup',
      component: Signup
    }, */
    /*
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout,
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      beforeEnter: AuthGuard,
    },*/
    /*
    {
      path: '/about',
      name: 'about',*/
      // route level code-splitting - a different way of importing a page / path
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      // component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
      /*component: About,
      beforeEnter: AuthGuard,
    },*/
    
  ],
});
